import MuiBox from '@material-ui/core/Box';
import MuiTypography from '@material-ui/core/Typography';
import MuiTooltip from '@material-ui/core/Tooltip';
import DistributionStatusIcon from '../DistributionStatusIcon';
import MuiInfoIcon from '@material-ui/icons/InfoOutlined';
import { DateTime } from 'luxon';

import styled from 'styled-components';

const DspGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  grid-gap: 4px;
`;

const DspCell = styled.div`
  border: 1px solid #d3d3d3;
  border-radius: 2px;
  display: grid;
  grid-template-columns: 24px 70px auto;
  grid-gap: 4px;
  padding: 4px;
`;

const CenteredDiv = styled.div`
  display: flex;
  align-items: center;
`;

function ReleaseDistributionStatus({ release, distributionJobs }) {
  //NOTE : Right now it pulls in the distribution jobs with the list of releases.
  //This is a bounded query with at most 25 at a time, but if for some reason
  //pulling in that much data leads to memory issues on the BE, We can do a use
  //query here instead for distrbution jobs on the specific release.

  const mostRecentJobs = distributionJobs.reduce((mostRecentJobsMap, currentJobSorting) => {
    if (
      !mostRecentJobsMap[currentJobSorting.dsp] ||
      mostRecentJobsMap[currentJobSorting.dsp].created_at < currentJobSorting.created_at
    )
      return { ...mostRecentJobsMap, [currentJobSorting.dsp]: currentJobSorting };

    return mostRecentJobsMap;
  }, {});

  return (
    <MuiBox my={1}>
      <MuiTypography variant="h6" gutterBottom component="div">
        Distribution Status
      </MuiTypography>
      <DspGrid>
        {distributionJobs?.length
          ? Object.entries(mostRecentJobs).map(([key, value], index) => {
              const dspStatus = value;
              return (
                <DspCell
                  key={`${index}-${dspStatus.dsp}`}
                  style={{
                    textTransform: 'capitalize',
                  }}>
                  <CenteredDiv>
                    <DistributionStatusIcon status={dspStatus.status} />
                  </CenteredDiv>
                  <CenteredDiv>{dspStatus.dsp}</CenteredDiv>
                  <CenteredDiv style={{ justifySelf: `flex-end` }}>
                    <MuiTooltip
                      title={`${dspStatus.status} - ${DateTime.fromISO(dspStatus.created_at).toLocaleString(
                        DateTime.DATETIME_SHORT
                      )}`}>
                      <MuiInfoIcon fontSize="inherit" color="disabled" />
                    </MuiTooltip>
                  </CenteredDiv>
                </DspCell>
              );
            })
          : 'No distribution jobs'}
      </DspGrid>
    </MuiBox>
  );
}

export default ReleaseDistributionStatus;
